<template>
  <div class="news w-default d-flex flex-colum ai-center">
    <h1 class="fs-xxxl">公司动态</h1>
    <ul class="w-100 d-flex f-warp" v-if="type==1">
      <li v-for="(item,index) in items" :key="index">
        <img v-bind:src="item.imgUrl" />
        <h2 class="text-default text-center fs-lg">{{item.title}}</h2>
        <p class="text-grey">{{item.detail}}</p>
        <p class="text-grey">{{item.date}}</p>
      </li>
    </ul>
    <ul class="w-100 d-flex f-warp" v-if="type==2">
      <li v-for="(item,index) in items.slice(0,3)" :key="index">
        <img v-bind:src="item.imgUrl" />
        <h2 class="text-default text-center fs-lg">{{item.title}}</h2>
        <p class="text-grey">{{item.detail}}</p>
        <p class="text-grey">{{item.date}}</p>
      </li>
    </ul>
    <button class="btn text-white" v-if="type==2" @click="$router.push('/News')">更多公司新闻 >></button>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String
    }
  },
  data() {
    return {
      items: [
        {
          imgUrl: require("../assets/img/news/2.jpg"),
          title: "安信校园驾驶舱SC-CC1.0上线",
          detail:
            "平台基于安信大数据平台开发，旨在以自助式数据探索与可视化分析方式，帮助学校洞悉数据背后隐藏的价值。",
          date: "2018-2-16"
        },
        {
          imgUrl: require("../assets/img/product/eg-2.jpg"),
          title: "安信一体化运维平台SC-AOP2.0上线",
          detail:
            "该平台致力于为企业一站式解决IT运维管理问题，实现监控一体化、保障智能化、运维自动化。",
          date: "2018-11-23"
        },
        {
          imgUrl: require("../assets/img/news/1.jpg"),
          title: "视频分析",
          detail:
            "视频分析领域取得突破性进展，应用于安防领域后，获得客户好评。",
          date: "2017-8-22"
        },
        {
          imgUrl: require("../assets/img/news/7.jpg"),
          title: "自然语言分析",
          detail:
            "自然语言分析取得突破，应用于文书比对后，获得良好效果。",
          date: "2017-7-12"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";
.news {
  h1 {
    margin-bottom: 40px;
  }
  ul {
    li {
      width: 372px;
      margin-right: 42px;
      &:nth-child(3n + 3) {
        margin-right: 0;
      }
      img {
        width: 100%;
        height: 300px;
        object-fit: cover;
        background: #cccccc;
        margin-bottom: 34px;
      }
      h2 {
        margin-bottom: 10px;
      }
      p {
        line-height: 2;
        margin-bottom: 6px;
        &:last-child {
          margin-bottom: 32px;
        }
      }
    }
  }
  .btn {
    width: 360px;
    height: 50px;
    background: map-get($colors, "primary");
  }
}
</style>